import zipValidation from '..'
import axios from 'axios'

/**
 *
 * @param zip
 * @param country
 * @param callback
 * @param self
 */
export default function(zip, country, callback, self){
    let api_name = '//ba-ws.geonames.net/postalCodeSearchJSON?'
    if(country === "USA" && zipValidation(zip, country) && zip !== ""){
        axios({
            method: 'get',
            url: api_name + "postalcode=" + zip + "&username=mpocitrix&country=US"
        }).then(function (response) {
            callback(response.data, self)
        }).catch(function(e){
            console.log('___ERROR____')
            console.log(e)
            console.log("___________")
        })
    }
}

